import { createFileRoute } from '@tanstack/react-router';
import { Option } from 'effect';
import { ApiDocsRoute } from '../../../api-docs/api-docs-route.tsx';

// The documentation opens on the first API the installation offers: its receiver contract when it
// serves one, the API a participant's backend calls first.
export const Route = createFileRoute('/documentacao/')({
  component: () => <ApiDocsRoute api={Option.none()} />,
});
